import { render, staticRenderFns } from "./ChooseSourcingMethod.vue?vue&type=template&id=01a0015a&scoped=true&"
import script from "./ChooseSourcingMethod.vue?vue&type=script&lang=js&"
export * from "./ChooseSourcingMethod.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSourcingMethod.vue?vue&type=style&index=0&id=01a0015a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a0015a",
  null
  
)

export default component.exports